import React from 'react'
import XCircleFillIcon from '../../../assets/icons/XCircleFill';
import ReactDatePicker from '../../../components/ReactDatePicker'

const ScheduleMessage = ({onClose, dateState, scheduleMessage,updateScheduleCount}) => {

  const scheduleMessageHandler = () => {
      scheduleMessage();
      updateScheduleCount();
      onClose();
  }
  return (
    <div className='overlay' onClick={onClose}>
      <div className='status_content_layout sechdule_layout' onClick={(e) => e.stopPropagation()}>
        <div className='content_header'>  
          <h2>Schedule Messge</h2>
          <button className='close-btn' onClick={onClose}><XCircleFillIcon size={24} /></button>
        </div>

        <div className="schedule_content_body">
            <div>
                <ReactDatePicker
                  label=""
                  placeholder="Select Schedule Date Time"
                  minDate={null}
                  dateState= {dateState}
                />
            </div>
            <div className='layout_footer'>
              <button className='save-btn' onClick={scheduleMessageHandler}>Schedule Message</button>
              <button onClick={onClose} className='cancel-btn'>Cancel</button>
            </div>
        </div>
      </div>
    </div>
  )
}

export default ScheduleMessage
